import axios from 'axios'

export default {
	getLatestNews() {
		return axios.get('/latest')
	},
	
	getOrgs() {
		return axios.get('/members')
	},
	getResources() {
		return axios.get('/resourcelist')
	},
	getSupporters() {
		return axios.get('/supporters')
	}
}
